<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerCurrentLineList' }">合作往来行</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details details_link">
                        <template v-for="(item, index) in colData">
                            <el-form-item :label="item.title + '：'" :key="index">
                                <div
                                    class="read_only read_only_link"
                                    v-if="item.prop == 'partner_current_rid' && data['partner_current_rid'] != ''"
                                >
                                    <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                </div>
                                <el-input
                                    v-else
                                    v-model="data[item.prop]"
                                    class="flex_item_text"
                                    size="mini"
                                    readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete } from '@/js/common';
export default {
    inject: ['reload'],
    name: 'partnerCurrentLineDetail',
    data() {
        return {
            colData: [],
            activeNames: ['1'],
            data: {},
            queryParams: {},
            headerTitle: '合作往来行详情'
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        toDetail(prop) {
            if (prop == 'partner_current_rid' && this.data.partner_current_rid != '') {
                this.$router.push({
                    path: '/partnerCurrentDetail',
                    query: {
                        id: this.data.partner_current_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).partner_current_line;
            delete this.colData['created_at'];
            delete this.colData['updated_at'];
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'partnerCurrentLineDelete', this.data.rid, 'partnerCurrentLineList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'partnerCurrentLineEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'partnerCurrentLineEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'partnerCurrentLineEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .partnerCurrentLineDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>